import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ICreateLeaveEncashmentRequest,
    ILeaveBalanceDetail,
    ILeaveEncashment,
} from '../interfaces/payroll.interface';

// Leave encashment lifecycle (spec §2.1). Create/list/remaining are institution-scoped; delete is
// keyed off the encashment id, with institutionId passed as a query param (§2.0 — the backend
// pairs the caller-supplied institutionId's PAYROLL_MANAGE check with a tenancy assert against
// the loaded row's own institutionId).
export const LeaveEncashmentService = {
    create: async (
        data: ICreateLeaveEncashmentRequest,
        institutionId: string
    ): Promise<ILeaveEncashment> => {
        const response = await axios.post(ENDPOINTS.LEAVE_ENCASHMENT.BASE(institutionId), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    list: async (institutionId: string, year?: number): Promise<ILeaveEncashment[]> => {
        const response = await axios.get(ENDPOINTS.LEAVE_ENCASHMENT.LIST(institutionId, year), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    remaining: async (
        institutionId: string,
        userId: string,
        leaveTypeId: string
    ): Promise<ILeaveBalanceDetail> => {
        const response = await axios.get(
            ENDPOINTS.LEAVE_ENCASHMENT.REMAINING(institutionId, userId, leaveTypeId),
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    delete: async (id: string, institutionId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.LEAVE_ENCASHMENT.DELETE(id, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
